import { makeInitialOpgavekompleksetTaskEntry, getValidatableOpgavekompleksetInputs, validateOpgavekompleksetInput } from '@utils/component-framework';

function updateStats(entry, data, taskId) {
  const taskEntry = entry.data.tasks[taskId] ??= makeInitialOpgavekompleksetTaskEntry(data, taskId);
  const validatableInputs = getValidatableOpgavekompleksetInputs(data, taskId, taskEntry);
  taskEntry.stats = {
    correct: 0,
    total: 0,
    wrong: 0
  };
  const nodeInputPairs = validatableInputs.map(input => ({
    node: input,
    entry: taskEntry.details[input.id]
  }));
  for (const inputPair of nodeInputPairs) {
    const result = validateOpgavekompleksetInput(inputPair.node, inputPair.entry, {
      inputs: nodeInputPairs
    });
    if (typeof result === "boolean") {
      taskEntry.stats.total++;
      if (result) {
        taskEntry.stats.correct++;
      } else {
        taskEntry.stats.wrong++;
      }
    } else {
      taskEntry.stats.total += result.correct + result.wrong;
      taskEntry.stats.correct += result.correct;
      taskEntry.stats.wrong += result.wrong;
    }
  }

  //
  // STEP: Update global stats based on latest values
  //
  entry.data.endTime = Date.now();
  entry.envelope.result = {
    status: "started",
    time: Math.round((entry.data.endTime - entry.data.startTime) / 1000),
    score: Object.values(entry.data.tasks).reduce((acc, curr) => ({
      pointsGotten: acc.pointsGotten + curr.stats.correct,
      pointsTotal: acc.pointsTotal + curr.stats.total
    }), {
      pointsTotal: 0,
      pointsGotten: 0
    })
  };
}

export { updateStats };
//# sourceMappingURL=util.update-stats.js.map
